<div class="line"></div>

@for (group of dataExtended().processGroups; track group) {
  <tps-navbar-button
    [label]="group.label()"
    matIcon=""
    tabType="none"
    [arrow]="getArrowIcon(group.expanded())"
    (click)="group.expanded.set(!group.expanded())"
  >
    <tps-process-status-badge icon [status]="group.status" size="large" />
  </tps-navbar-button>

  @if (group.expanded()) {
    @for (process of group.processes; track process) {
      <tps-navbar-button
        [label]="process.label()"
        [url]="process.url?.()"
        [name]="process.name"
        [parentTab]="parentTab()"
        matIcon=""
        tabType="none"
        (click)="!process.url?.() && processClicked.emit(process)"
      >
        <tps-process-status-badge icon [status]="process.status" size="small" />
      </tps-navbar-button>
    }
  }
}
